// extracted by mini-css-extract-plugin
export default {"container":"g6jCAfU7VrcC2rPD3CwQ","background":"IMmRPGG4H3lxBeYgxJfk","card":"NEsE9HDJsfEv9xhbo5Jh"};